import script from "./recordVideo.vue?vue&type=script&setup=true&lang=js"
export * from "./recordVideo.vue?vue&type=script&setup=true&lang=js"

import "./recordVideo.vue?vue&type=style&index=0&id=0e977910&lang=less&scoped=true"

import exportComponent from "/data/web/antpay-h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e977910"]])

export default __exports__